<template>
  <v-card>
    <v-card-title class="headline error white--text">
      <span>Error Log {{ errorCount }}</span>
      <v-spacer></v-spacer>
      <v-btn icon dark class="m-0" @click="root.dialog = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="p-0">
      <div v-if="errorMessage != null">{{ errorMessage }}</div>
      <v-expansion-panels class="m-0" v-if="computationLog != null">
        <v-expansion-panel
          v-for="(error, key) in computationLog.errors"
          :key="key"
        >
          <v-expansion-panel-header>
            <div>{{ key }} : {{ error.message }}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-treeview :items="getItems(JSON.parse(error.inputs))" hoverable>
              </v-treeview>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'error-log-display',

  props: ['root', 'computationLog', 'errorMessage'],
  computed: {
    errorCount() {
      if (this.computationLog?.errors?.length != null) {
        return '(' + this.computationLog.errors.length + ')'
      }
      return ''
    }
  },
  methods: {
    getItems(inputs) {
      let items = []
      if (!inputs) {
        return items
      }
      let keys = Object.keys(inputs)
      for (let key of keys) {
        let item = inputs[key]
        if (typeof item === 'object' && item != null) {
          items.push({ name: key, children: this.getItems(item) })
        } else {
          items.push({ name: '- ' + key + ': ' + item })
        }
      }
      return items
    }
  }
}
</script>
